/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  elasticDescription: {
    id: 'elasticInstance.elasticDescription',
    defaultMessage: `Connect to your Elasticsearch instance.`
  },
  learnMore: {
    id: 'elasticInstance.learnMore',
    defaultMessage: 'Learn more'
  },
  description: {
    id: 'elasticInstance.description',
    defaultMessage: `Fill in the information below to access your Elasticsearch instance.`
  },
  urlLabelText: {
    id: 'elasticInstance.urlLabelText',
    defaultMessage: `Elasticsearch url`
  },
  urlPlaceholder: {
    id: 'elasticInstance.urlPlaceholder',
    defaultMessage: `exampleUrl.com`
  },
  portLabelText: {
    id: 'elasticInstance.portLabelText',
    defaultMessage: `Elasticsearch port (optional)`
  },
  portPlaceholder: {
    id: 'elasticInstance.portPlaceholder',
    defaultMessage: `123`
  },
  indexPlaceholder: {
    id: 'elasticInstance.indexPlaceholder',
    defaultMessage: `exampleIndex`
  },
  authTypeLabelText: {
    id: 'elasticInstance.authTypeLabelText',
    defaultMessage: `Choose an authentication type`
  },
  usernameLabelText: {
    id: 'elasticInstance.usernameLabelText',
    defaultMessage: `Elasticsearch username`
  },
  usernamePlaceholder: {
    id: 'elasticInstance.usernamePlaceholder',
    defaultMessage: `exampleUser`
  },
  passwordLabelText: {
    id: 'elasticInstance.passwordLabelText',
    defaultMessage: `Elasticsearch password`
  },
  apiKeyLabelText: {
    id: 'elasticInstance.apiKeyLabelText',
    defaultMessage: `Elasticsearch API key`
  },
  invalidEmptyValueText: {
    id: 'elasticInstance.invalidEmptyValueText',
    defaultMessage: `Value can't be empty.`
  },
  invalidUrlValueText: {
    id: 'elasticInstance.invalidUrlValueText',
    defaultMessage: `Value must be a valid url, ex. "https://www.example.com".`
  },
  loadIndicesButtonLabel: {
    id: 'elasticInstance.loadIndicesButtonLabel',
    defaultMessage: `Load indices`
  },
  reloadIndicesButtonLabel: {
    id: 'elasticInstance.reloadIndicesButtonLabel',
    defaultMessage: `Reload indices`
  },
  indicesDropdownTitle: {
    id: 'elasticInstance.indicesDropdownTitle',
    defaultMessage: `Load Elasticsearch indices and choose one to use`
  },
  indicesDropdownTooltip: {
    id: 'elasticInstance.indicesDropdownTooltip',
    defaultMessage:
      'In order to load Elasticsearch indices when editing an Elasticsearch integration you will need to re-enter your credentials (password or API key) above.'
  },
  indicesDropdownPlaceholderLabel: {
    id: 'elasticInstance.indicesDropdownPlaceholderLabel',
    defaultMessage: `--`
  },
  loadingIndices: {
    id: 'elasticInstance.loadingIndices',
    defaultMessage: 'Loading indices...'
  },
  indexTextfieldLabel: {
    id: 'elasticInstance.indexTextfieldLabel',
    defaultMessage: `Or manually enter Elasticsearch index`
  },
  update: {
    id: 'elasticInstance.update',
    defaultMessage: `Update`
  }
});
